module.exports = __webpack_public_path__ + "static/media/BARCOO SHIRE.a02a6220.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_areas/BARCOO SHIRE.svg
// module id = 522
// module chunks = 0